import { Link } from 'react-router-dom';
import { getPlanDisplayName } from '../lib/plans';
import { isLocked, planInEffect, trialCountdown } from '../lib/workspaces';
import type { Workspace } from '../types/database';

// The plan box in the sidebar and workspace settings: the Trial countdown, or prompts used.
export function PlanLimits({
  workspace,
  promptUsed,
  onUpgrade,
}: {
  workspace: Workspace | null;
  promptUsed: number;
  onUpgrade: () => void;
}) {
  const state = workspace?.state;
  const { daysLeft, totalDays } = trialCountdown(workspace);
  const promptLimit = workspace?.prompt_limit ?? 0;

  const title =
    state === 'trial'
      ? `${totalDays} day free trial`
      : state === 'lapsed'
        ? 'Free trial ended'
        : state === 'cancelled'
          ? 'Subscription ended'
          : `${workspace?.plan ? getPlanDisplayName(planInEffect(workspace)) : ''} plan`;

  const detail =
    state === 'trial'
      ? `${daysLeft} day${daysLeft !== 1 ? 's' : ''} remaining`
      : `${promptUsed.toLocaleString()} of ${promptLimit.toLocaleString()} prompts used`;

  const filled =
    state === 'trial'
      ? totalDays ? Math.min(100, Math.round((daysLeft / totalDays) * 100)) : 0
      : promptLimit ? Math.min(100, Math.round((promptUsed / promptLimit) * 100)) : 0;

  return (
    <div className="plan-limits">
      <div>{title}</div>
      <div className="spacer-tiny"></div>
      <div className="line-divider is-horizontal"></div>
      {/* A Locked workspace has no countdown or usage to show. */}
      {!isLocked(workspace) && (
        <>
          <div className="spacer-tiny"></div>
          <div className="text-size-small text-weight-medium text-colour-alt-grey">{detail}</div>
          <div className="spacer-tiny"></div>
          <div className="remaining-range">
            <div className="range-filled" style={{ width: `${filled}%` }}></div>
          </div>
        </>
      )}
      <div className="spacer-xsmall"></div>
      <Link to="/plans" className="button is-small is-wide w-button" onClick={onUpgrade}>
        Upgrade now
      </Link>
    </div>
  );
}
